import React from 'react'

import ArrowRightIconMedium from './ArrowRightIconMedium'
import ArrowRightIconSmall from './ArrowRightIconSmall'
import { DynamicIconProps } from '../../../../types'

/**
 * @deprecated This icon is going to be removed in the future
 * Please use the ArrowForward as an alternative
 */

const ArrowRightIcon: React.FC<DynamicIconProps> = ({ size = 'medium', ...props }) =>
  size === 'medium' ? <ArrowRightIconMedium {...props} /> : <ArrowRightIconSmall {...props} />

export default ArrowRightIcon
